export default {
  个人信息: "個人資訊",
  用户姓名: "用戶姓名",
  工号: "工號",
  部门: "部門",
  岗位: "崗位",
  邮箱: "郵箱",
  帳号密码信息: "帳號密碼資訊",
  修改帳号密码: "修改帳號密碼",
  获取验证码: "獲取驗證碼",
  下一步: "下一步",
  邮箱号: "郵箱號",
  请输入邮箱: "請輸入郵箱！",
  请输入有效的邮箱格式: "請輸入有效的郵箱格式",
  验证码: "驗證碼",
  请输入验证码: "請輸入驗證碼！",
  s后重試: "s後重試",
  密码修改成功: "密碼修改成功，請使用新密碼登錄",
  邮箱验证失敗: "郵箱驗證失敗",
};
